import {ReactNode} from 'react';
import {NavLink} from 'react-router-dom';
import styled from 'styled-components';
import {paths} from '@/router';
import {FlexCenter} from '@/styled-components';
import {LAYOUT_SIZE, LAYOUT_Z_INDEX, palette} from '@/styles';
import LogoImg from './assets/logo.svg';

interface IProps {
  children?: ReactNode;
}

export const Sidebar = ({children}: IProps) => {
  return (
    <Root>
      <Logo>
        <NavLink to={paths.map_root}>
          <img src={LogoImg} alt="마이프차" />
        </NavLink>
      </Logo>
      {children}
    </Root>
  );
};

const Root = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: ${LAYOUT_Z_INDEX.SIDE_PANEL + 1};
  width: ${LAYOUT_SIZE.SIDE_BAR}px;
  height: 100%;
  background-color: ${palette.white};
  border-right: solid 1px ${palette.gray300};
`;

const Logo = styled(FlexCenter)`
  width: 100%;
  height: ${LAYOUT_SIZE.SIDE_BAR}px;
`;
